import * as React from 'react';
import { Row, Col } from 'react-bootstrap';

import { SegmentLabel } from '@acceligentllc/storybook';

interface OwnProps {
	label: string;
	tooltip?: string;
}

type Props = React.PropsWithChildren<OwnProps>;

const Section: React.FC<Props> = ({ label, tooltip, children }) => {
	return (
		<>
			<Row>
				<Col className="p-t-m p-b-m p-l-s" sm={24}>
					<SegmentLabel label={label} tooltip={tooltip} tooltipPosition={!!tooltip ? 'right' : undefined} />
				</Col>
			</Row>
			<Row className="row--padded-bottom work-order-upsert__section">
				{children}
			</Row>
		</>
	);
};

export default Section;
